import React from 'react';
import Post from "../../../components/pages/form/Post/Post";

const PostPage = () => {
    return <Post/>
};

export default PostPage;